/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { Default } from "../Default";
import "./style.css";

export const NavigationButton = ({
  type,
  platform,
  state,
  theme,
  focus,
  className,
  defaultMasterButtonNavDivClassName,
}) => {
  return (
    <div className={`navigation-button ${className}`}>
      <Default
        className="master"
        masterButtonNavDivClassName={defaultMasterButtonNavDivClassName}
        masterButtonNavHasIconButton={false}
        masterButtonNavText="Back"
      />
    </div>
  );
};

NavigationButton.propTypes = {
  type: PropTypes.oneOf(["back"]),
  platform: PropTypes.oneOf(["web-react"]),
  state: PropTypes.oneOf(["default"]),
  theme: PropTypes.oneOf(["light"]),
  focus: PropTypes.bool,
};
